import { getMessages } from '../../../../../store/constants';

export const NAV_PANEL_QUICK_START_GUIDE_HINT = getMessages().getText('quick_start_guides.hint');
